export const state = () => ({
  defaultNumbOfScreelsToFetch: 6, // for the feeds page default number of screels to fetch
  availableReactions: [],
});
